import { AfterViewInit, Component, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CustomersFacadeService } from "../../services/customers-facade.service";
import {
  CascadeInvoice,
  CascadeSellInvoiceItem,
} from "../../models/customers.model";
import { SnackBarService } from "src/app/shared/services/snackbar/snackbar";
import { ResolverService } from "src/app/core";
import { Profile } from "src/app/core/models/initials.model";
import { environment } from "src/environments/environment";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-customers-invoice-print",
  templateUrl: "./customers-invoice-print.component.html",
  styleUrls: ["./customers-invoice-print.component.scss"],
})
export class CustomersInvoicePrintComponent implements OnInit {
  isSelfInvoice: boolean = false;
  invoiceDetails: CascadeInvoice;
  invoiceItems: any[];
  titles: string[] = [
    "No",
    /*'Company',*/ "PRODUCT",
    "QUANTITY",
    "UNIT PRICE",
    "TOTAL PRICE",
  ];
  topLevelUser: Profile;
  invoiceUserData: Profile;
  isAdmin: boolean = false;
  showInvoiceHeader: boolean = true;
  piNumber: string;
  environmentConfig = environment;
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private customerService: CustomersFacadeService,
    private snackbarService: SnackBarService,
    private resolvedService: ResolverService,
    private titleService: Title,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.getUrlData();
    if (
      this.resolvedService.userInitInfo.profile.role.role_id ==
      environment.role_types.admin
    ) {
      this.piNumber = window.prompt("Enter PI Number(Optional)");
    }
  }

  getUrlData() {
    this.activatedRoute.params.subscribe((params) => {
      const id = params.id;
      this.activatedRoute.queryParams.subscribe((query) => {
        if (query.self == "1") this.isSelfInvoice = true;
        this.showInvoiceHeader = !this.isSelfInvoice;
        this.getInvoiceDetails(id);
        this.getInvoiceItems(id);
        this.setupHeaderData();
      });
    });
  }

  setupHeaderData() {
    this.topLevelUser = { ...this.resolvedService.userInitInfo.profile };
    this.isAdmin =
      this.topLevelUser.role.role_id == environment.role_types.admin;
    if (this.isAdmin) {
      this.showInvoiceHeader = true;
    }
    if (this.isAdmin) {
      this.showInvoiceHeader = true;
      this.topLevelUser.company = environment.title;
      // this.topLevelUser.address = `7940 Silverton Ave. Suite 101-A
      //         San Diego, CA 92126`;
      this.topLevelUser.company_logo = environment.logoPrintSrc
      this.topLevelUser.email = environment.email;
      this.topLevelUser.phone = environment.webUrl;
    } else if(this.isSelfInvoice){
      if (!this.topLevelUser.reseller) {
        this.showInvoiceHeader = true;
        this.topLevelUser.company = environment.title;
        this.topLevelUser.address = `7940 Silverton Ave. Suite 101-A
                San Diego, CA 92126`;
        this.topLevelUser.company_logo = environment.logoPrintSrc
        this.topLevelUser.email = environment.email;
        this.topLevelUser.phone = environment.webUrl;
      } else {
        this.showInvoiceHeader = true;
        this.topLevelUser = {
          ...this.resolvedService.userInitInfo.profile.reseller,
        };
      }
    }
  }

  getInvoiceUserData(id) {
    this.customerService.getUserProfileById(id).subscribe((data) => {
      this.invoiceUserData = data;
    });
  }

  getInvoiceDetails(id: number) {
    const filter = {
      type: this.isSelfInvoice ? 1 : 2,
    };

    this.customerService.getCascadeSellInvoiceDetails(id, filter).subscribe(
      (details) => {
        this.invoiceDetails = details;
        this.titleService.setTitle(`Invoice #${details.invoice_code}`);
        if (!this.isSelfInvoice) {
          this.getInvoiceUserData(details.user.profile_id);
        } else {
          this.invoiceUserData = this.resolvedService.userInitInfo.profile;
        }
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  getInvoiceItems(id: number) {
    const filter = {
      type: this.isSelfInvoice ? 1 : 2,
    };

    this.customerService.getCascadeSellInvoiceItems(id, filter).subscribe(
      (items) => {
        this.invoiceItems = items;
        window.onbeforeprint = function () {
          var table: any = document.getElementById("invoice-table");
          if (table) {
            if (table.rows.length == 10) {
              table.rows[9].classList.add("page-break");
            }
            if (table.rows.length > 9) {
              var rows = table.rows;
              rows[9].classList.add("page-break");
              let i = 9;
              while (i < table.rows.length) {
                if (rows[16 + i]) {
                  rows[16 + i].classList.add("page-break");
                }
                i = i + 16;
              }
            }
          }
        };
      },
      (error) => {
        this.snackbarService.showSnack(error.detail);
      }
    );
  }

  checkPaperSize() {
    console.log("in check paper size", window.matchMedia);
    if (window.matchMedia) {
      var mediaQueryList = window.matchMedia(
        "print and (width: 5.8in) and (height: 8.3in)"
      );
      if (mediaQueryList.matches) {
        var table: any = document.getElementById("invoice-table");

        if (table) {
          var rows = table.rows;
          if (rows.length > 7) {
            rows[7].classList.add("page-break");
          }
        }
      }
    }
  }

  getLocalTimezone() {
    return this.resolvedService.userInitInfo.profile.timezone_data
      ? this.resolvedService.userInitInfo.profile.timezone_data.code
      : "UTC";
  }

  printInvoice() {
    window.print();
  }

  calcTotal() {
    if (this.invoiceItems) {
      return this.invoiceItems.reduce(
        (sum, current) => sum + current.count * current.unit_price,
        0
      );
    }
  }

  calcRemainingBalance() {
    return this.invoiceDetails.remaining_balance - this.invoiceDetails.credits;
  }
}
